// extracted by mini-css-extract-plugin
module.exports = {"panel--bottom":"styles__panel--bottom___qAXOV","panel--top":"styles__panel--top___X4Buw"};